<template>
	<div class="calendar_horse_content d-flex flex-column h-100">
		<template v-if="!params.mare && !params.tiers && !params.contact">
			<div class="d-flex h-100 justify-content-center align-items-center">
				<button class="btn btn-secondary mr-2" @click="unlock_creneau"><font-awesome-icon :icon="['far', 'lock']" /></button>
				<b-button pill variant="primary" @click="edit">
					<font-awesome-icon :icon="['fal', 'marker']"></font-awesome-icon><span class="d-none d-md-inline d-lg-none"> {{ $t('global.editer') }}</span>
				</b-button>
			</div>
			<div v-if="commentaire_text" class="alert mt-2 mb-0 py-1 px-2" :class="'alert-' + commentaire_color">
				<span class="comment-html" v-html="commentaire_text"></span>
			</div>
		</template>
		<template v-else>
			<div class="d-flex justify-content-between align-items-start">
				<div class="flex-grow-1 w-100 min-width-0">
					<div class="d-md-none d-inline">
						{{ schedule.schedule_start }}h {{ schedule.schedule_end }}h
					</div>
					<template v-if="params.mare && params.mare.horse_nom">
						<router-link :to="{ name: 'horseFiche', params: { horse_id: params.mare.horse_id }}" class="horse-name-link">
							<b>{{ params.mare.horse_nom }}</b>
						</router-link>
						<small>
							<template v-if="!params.prev_sms && params.season_mare && params.season_mare.seasonmare_status">{{ $t('gynecologie.'+params.season_mare.seasonmare_status) }}<br /></template>				
							<template v-if="params.mare.horse_transpondeur"><font-awesome-icon :icon="['fal', 'microchip']" class="mr-1" />{{ transpondeurShort }}<br /></template>
							<template v-if="params.prev_sms && params.prev_sms.seasonmarestallion_status">{{ $t('monte.etat_n1') }} : {{ params.prev_sms.seasonmarestallion_status }}</template>
						</small>
					</template>
				</div>
				<div class="d-flex flex-nowrap">
					<b-button pill variant="primary" class="py-1 px-2 calendar_btn_edit" @click="edit">
						<font-awesome-icon :icon="['fal', 'marker']"></font-awesome-icon><span class="d-none d-md-inline d-lg-none"> {{ $t('global.editer') }}</span>
					</b-button>
					<b-button pill variant="secondary" class="py-1 px-2 ml-1 calendar_btn_edit" @click="deleteSchedule">
						<font-awesome-icon :icon="['fal', 'trash-alt']"></font-awesome-icon><span class="d-none d-md-inline d-lg-none"> {{ $t('global.supprimer') }}</span>
					</b-button>
				</div>
			</div>
			<div class="cell-addresses d-flex flex-column mt-1">
				<small v-if="params.contact" class="cell-address">
					<font-awesome-icon :icon="['fal', 'briefcase']" class="mr-1" />{{ params.contact.contact_firstname }} {{ params.contact.contact_lastname }}
					<template v-if="params.contact.phone.length > 0">
						<a :href="buildWhatsappLink(params.contact.phone[0])" target="_blank" rel="noopener" :title="$t('monte.notify_whatsapp')">
							<font-awesome-icon :icon="['fab', 'whatsapp']" class="text-success mr-1" />{{ formatPhone(params.contact.phone[0]) }}
						</a>
					</template>
				</small>
				<small v-else-if="params.tiers" class="cell-address">					
					<router-link :to="{ name: 'tiersFiche', params: { tiers_id: params.tiers.tiers_id }}" class="horse-name-link"><font-awesome-icon :icon="['fal', 'briefcase']" class="mr-1" /> {{ params.tiers.tiers_rs }}</router-link>
					<template v-if="params.tiers.phone.length > 0">
						<a :href="buildWhatsappLink(params.tiers.phone[0])" target="_blank" rel="noopener" :title="$t('monte.notify_whatsapp')">
							<font-awesome-icon :icon="['fab', 'whatsapp']" class="text-success mr-1" />{{ formatPhone(params.tiers.phone[0]) }}
						</a>
					</template>
				</small>
				<small v-if="params.mare && params.mare.lieu_stationnement" class="cell-address mt-1">
					<router-link :to="{ name: 'tiersFiche', params: { tiers_id: params.mare.lieu_stationnement.tiers_id }}" class="horse-name-link"><font-awesome-icon :icon="['fal', 'map-marker-alt']" class="mr-1" /> {{ params.mare.lieu_stationnement.tiers_rs }}</router-link>
					<template v-if="params.mare.lieu_stationnement.phone && params.mare.lieu_stationnement.phone.length > 0">
						<a :href="buildWhatsappLink(params.mare.lieu_stationnement.phone[0])" target="_blank" rel="noopener" :title="$t('monte.notify_whatsapp_lieu')">
							<font-awesome-icon :icon="['fab', 'whatsapp']" class="text-success mr-1" />{{ formatPhone(params.mare.lieu_stationnement.phone[0]) }}
						</a>
					</template>
				</small>
			</div>
			<div v-if="commentaire_text" class="alert mt-2 mb-1 py-1 px-2" :class="'alert-' + commentaire_color">
				<span class="comment-html" v-html="commentaire_text"></span>
			</div>
			<div v-if="params.mare && params.mare.horse_nom" class="cell-actions mt-auto pt-2">
				<b-button-group size="sm" class="w-100">
					<b-button v-if="!contract" :class="class_contract" variant="secondary" class="p-1" @click="createContract">
						<font-awesome-icon :icon="['fal', 'edit']"></font-awesome-icon><span class="d-none d-lg-inline"> {{ $t('monte.contrat_a_faire') }}</span>
					</b-button>
					<b-button v-else-if="contract && contract.last_avenant.avenant_status == 3" class="green p-1" variant="secondary" @click="openContract">
						<font-awesome-icon :icon="['fal', 'edit']"></font-awesome-icon>
						<span class="d-none d-lg-inline"> {{ $t('monte.contrat_signe') }} </span>
						<span :class="class_contract"> €</span>
					</b-button>
					<b-button v-else class="red p-1" variant="secondary" @click="openContract">
						<font-awesome-icon :icon="['fal', 'edit']"></font-awesome-icon>
						<span class="d-none d-lg-inline"> {{ $t('monte.contrat_a_signe') }} </span>
						<span :class="class_contract"> €</span>
					</b-button>

					<b-button :class="(params.season_mare && params.season_mare.seasonmare_sanitary ? 'green' : 'red') + ' p-1'" variant="secondary" @click="openActe">
						<font-awesome-icon :icon="['fal', 'syringe']"></font-awesome-icon><span class="d-none d-lg-inline"> {{ $t('monte.sanitaire') }}</span>
					</b-button>
					<b-button :class="params.saillie + ' p-1'" variant="secondary" @click="openAddActe" v-b-tooltip.hover.top :title="$t('monte.info_couleur_saillie')">
						<font-awesome-icon :icon="['fal', 'venus-mars']"></font-awesome-icon><span class="d-none d-lg-inline"> {{ $t('monte.saillie') }}</span>
					</b-button>
				</b-button-group>
			</div>
		</template>
	</div>
</template>



<script type="text/javascript">
	import Vue from 'vue'
	import Contract from '@/mixins/Contract'
	import Tiers from '@/mixins/Tiers'
	import Gynecologie from '@/mixins/Gynecologie'
	import Shutter from '@/mixins/Shutter'
	import MonteShutters from '@/mixins/shutters-manager/Monte'
	import { parsePhoneNumberFromString as parseMax, AsYouType } from 'libphonenumber-js/max'

	export default {
		name: 'CellCalendarMainBeta',
		mixins: [Contract, Tiers, Gynecologie, Shutter, MonteShutters],
		props: ['schedule', 'params', 'edit_schedule', 'delete_schedule', 'delete_schedule_force'],
		data () {
			return {
				contract: null,
				mare_status: null,
				season_mare: null,
				class_contract: '',
				sms: null,
				saillie: [],
				avenant: null
			}
		},

		mounted() {
			this.init_component()
		},

		methods: {
			async init_component() {
				if(this.params.contract) {
					this.class_contract = this.params.solde ? 'd-none' : 'text-danger'
					this.contract = this.params.contract
				}
			},

			edit() {
				this.$emit('update:edit_schedule', {schedule_info: this.params, schedule_id: this.schedule.schedule_id, horse_id: this.params.stallion.horse_id, season_mare: this.season_mare})
			},

			openActe() {
				if(this.shutterPanel().isOpen('acte-jument')) {
					this.shutterPanel().close('acte-jument')
					return false
				}

                this.shutterPanel().keepGiven('monte-main-calendar-beta')
				const shutter = this.monteShutters['acte-jument']
				shutter.props.horse_id = this.params.mare.horse_id
				shutter.props.horse_nom = this.params.mare.horse_nom

				shutter.onOk = () => {
					this.shutterPanel().close('acte-jument')
				}

				this.shutterPanel().open(shutter)
			},

			openAddActe() {
				if(this.shutterPanel().isOpen('ajout-acte')) {
					this.shutterPanel().close('ajout-acte')
					return false
				}

				this.shutterPanel().keepGiven('monte-main-calendar-beta')
				const shutter = this.monteShutters['ajout-acte']
				shutter.props.horses_ids = [this.params.mare.horse_id]
				shutter.props.actes_ids = this.params.saillie_id ? [this.params.saillie_id] : []
				shutter.props.group_preselect = "REPRO"
				shutter.props.type_preselect = "REPRO_SAILLIE_EN_MAIN"
				shutter.props.date_preselect = this.params.saillie_id ? null : new Date(this.params.date)
				shutter.props.preselect = this.params.stallion.horse_nom

				shutter.onOk = () => {
					this.shutterPanel().close('ajout-acte')
				}

				this.shutterPanel().open(shutter)
			},

			async createContract() {
				if(this.params.mare.horse_id) {
					const tiers = await this.loadTiersHorse(this.params.mare.horse_id)
					if(tiers.length == 0) {
						this.failureToast("monte.jument_no_tiers")
						this.showAjoutTiers()
						return false
					}

					const contract_id = await this.addContractOnlineFromHorse(this.params.mare.horse_id)
					this.infos_contract = await this.getContractOnline(contract_id)
					this.contract = this.infos_contract[0].contract
					this.contract.last_avenant = this.infos_contract[0].avenant
				} else {
					const contract_id = await this.addContractOnline()
					this.infos_contract = await this.getContractOnline(contract_id)
					this.contract = this.infos_contract[0].contract
					this.contract.last_avenant = this.infos_contract[0].avenant
				}
				this.openContract()
			},

			showAjoutTiers() {
				this.shutterPanel().keepGiven('monte-main-calendar-beta')
				const shutter = this.monteShutters['ajout-tiers-mare']
				shutter.props.horse = this.params.mare

				shutter.onOk = () => {
					this.shutterPanel().close('ajout-tiers-mare')
					this.createContract()
				}

				this.shutterPanel().open(shutter)
			},

			openContract() {
				if(this.shutterPanel().isOpen('contrat')) {
					this.shutterPanel().close('contract-a-valider')
					this.shutterPanel().close('contract-bons-valider')
					this.shutterPanel().close('contract-invoices')
					this.shutterPanel().close('contrat')
					return false
				}

				this.shutterPanel().keepGiven('monte-main-calendar-beta')
				const shutter = this.monteShutters['contrat']
				shutter.props.contract_id = this.contract.contract_id
				shutter.props.stallion_id = this.params.stallion ? this.params.stallion.horse_id : undefined

				shutter.onOk = () => {
					this.shutterPanel().close('contrat')
				}

				this.shutterPanel().open(shutter)
			},

			deleteSchedule() {
				this.$emit('update:delete_schedule', {schedulehorse_id: this.params.id})
			},

			formatPhone(number) {
				return new AsYouType(Vue.i18n.locale()).input(number)
			},

			/**
			 * Construit le lien wa.me pour notifier le destinataire du RDV de monte
			 * @param {string} phone numéro combiné (ex: +33612345678)
			 * @returns {string}
			 */
			buildWhatsappLink(phone) {
				const clean = phone ? String(phone).replace(/[^0-9]/g, '') : ''
				const mare_nom = this.params.mare && this.params.mare.horse_nom ? this.params.mare.horse_nom : ''
				const stallion_nom = this.params.stallion && this.params.stallion.horse_nom ? this.params.stallion.horse_nom : ''
				const date_str = this.params.date ? new Date(this.params.date).toLocaleDateString(Vue.i18n.locale()) : ''
				const heure_str = this.schedule && this.schedule.schedule_start ? this.schedule.schedule_start : ''
				const message = this.getTrad('monte.whatsapp_message', {
					mare: mare_nom,
					stallion: stallion_nom,
					date: date_str,
					heure: heure_str
				})
				return 'https://wa.me/' + clean + '?text=' + encodeURIComponent(message)
			},

			unlock_creneau() {
				this.$emit('update:delete_schedule_force', {schedulehorse_id: this.params.id})
			}
		},

		computed: {
			commentaire_formatted() {
				return this.params.commentaire //.substr(0, 25) + '...'
			},
			/**
			 * Retourne les 6 derniers caractères du transpondeur formattés en deux blocs de 3
			 */
			transpondeurShort() {
				const t = this.params.mare && this.params.mare.horse_transpondeur ? String(this.params.mare.horse_transpondeur) : ''
				const tail = t.length > 6 ? t.slice(-6) : t
				return tail.length === 6 ? tail.slice(0, 3) + ' ' + tail.slice(3) : tail
			},
			/**
			 * Texte du commentaire de cellule
			 */
			commentaire_text() {
				return this.params.commentaire || ''
			},
			/**
			 * Couleur (variante Bootstrap) du commentaire, ou couleur par défaut
			 */
			commentaire_color() {
				return this.params.commentaire_color || 'info'
			}
		}
	}

</script>

<style scoped>
.cell-addresses {
	border: 0;
}
</style>